import * as CONSTANTS from "../constants/actions/promoBanner";

const keyMap = {
    Title: 'title',
    ImageURL: 'imageUrl',
    PromoBody: 'body',
    DisplayEnabled: 'displayEnabled'
};

/** 
 * @name INITIAL_STATE
 * @constant 
 * @description
 * @type {Object}
 * @default
*/
const INITIAL_STATE = {
    title: '',
    imageUrl: '',
    body: '',
    displayEnabled: false
};

/**
 * **DO NOT** Manipulate the state directly, always apply to a new object first!! If you don't redux will not 
 * recognize a change in the data and the components will not receive the correct information.
 * 
 * @name reducer
 * @function
 * @description Handles reduction of data accross components for the piece of the site implied by the filename
 * @param {Object} state Current state of the data
 * @param {Object} action Information passed from the corresponding actions file
 */
const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CONSTANTS.SET_PROMO_BANNER:

            if (!action.payload.details) {
                return state;
            }

            // set data based on key map.
            const details = action.payload.details.reduce((acc, { Key, Value }) => {
                if (keyMap[Key]) {
                    acc[keyMap[Key]] = Value;
                }
                return acc;
            }, {});

            // extracting / setting the image url.
            const doc = (new DOMParser()).parseFromString(details.imageUrl, 'text/html');
            const link = doc.querySelector('link');
            details.imageUrl = link?.getAttribute('url');

            return {
                ...state,
                ...details
            };

        default:
            return state;
    }
}

export default reducer;